import React from "react";

const STYLE = {
  PAID: "text-[#ccff00] border-[#ccff00]/40", ACTIVE: "text-[#ccff00] border-[#ccff00]/40", COMPLETED: "text-[#ccff00] border-[#ccff00]/40",
  AWAITING_PAYMENT: "text-sky-300 border-sky-300/40", CREATED: "text-sky-300 border-sky-300/40", CONFIRMING: "text-sky-300 border-sky-300/40",
  PENDING_APPROVAL: "text-sky-300 border-sky-300/40", APPROVED_FOR_MANUAL_EXECUTION: "text-sky-300 border-sky-300/40", PROCESSING: "text-sky-300 border-sky-300/40",
  PARTIALLY_PAID: "text-amber-300 border-amber-300/40", REVIEW_REQUIRED: "text-amber-300 border-amber-300/40", GRACE_PERIOD: "text-amber-300 border-amber-300/40",
};
const LABEL = { AWAITING_PAYMENT: "Awaiting payment", PARTIALLY_PAID: "Partially paid", REVIEW_REQUIRED: "Under review",
  GRACE_PERIOD: "Grace period", PENDING_APPROVAL: "Pending approval", APPROVED_FOR_MANUAL_EXECUTION: "Approved: execute in NOWPayments" };

export function StatusBadge({ status }) {
  return (
    <span data-testid="status-badge" className={`inline-flex px-2.5 py-1 rounded-full border text-[10px] font-mono-cl uppercase tracking-[0.12em] ${STYLE[status] || "text-zinc-400 border-white/15"}`}>
      {LABEL[status] || status?.replace(/_/g, " ").toLowerCase()}
    </span>
  );
}

export function DemoBadge() {
  return <span data-testid="demo-badge" className="inline-flex px-2.5 py-1 rounded-full bg-fuchsia-500/15 text-fuchsia-300 border border-fuchsia-400/30 text-[10px] font-mono-cl uppercase tracking-[0.16em]">Demo</span>;
}
